module.exports = __webpack_public_path__ + "img/ic_suc_60.e5d221f4.svg";